import { useAppDispatch } from 'store/hooks';
import settingStaffActions from '../actions';
import { useEffect } from 'react';
import turnSelectors from '../selectors';

const useGetListServiceCode = (isLazy = false) => {
  const dispatch = useAppDispatch();
  const listServiceCode = turnSelectors.getListServiceCode();

  const mutate = () => {
    dispatch(settingStaffActions.getListServiceCode.fetch());
  };

  useEffect(() => {
    if (!isLazy) {
      mutate();
    }
  }, []);

  return {
    listServiceCode,
    mutate,
  };
};
export default useGetListServiceCode;
